import Candidates from "@pages/hiringCompany/requirements/candidates/candidates";
import JobApplicantDetail from "@pages/JobPage/JobApplicantDetail/JobApplicantDetail";
import RequirementsPage from "@pages/hiringCompany/requirements/requirements";
import { Navigate, RouteObject } from "react-router-dom";
import { routerLoaders } from "router";
import MeetingLayout from "@pages/CalendarsPage/MeetingLayout";
import RecruitmentAgents from "@pages/hiringCompany/recruitmentAgents/recruitmentAgents";
import RecruitmentAgentsAccessGuard from "@pages/hiringCompany/recruitmentAgents/RecruitmentAgentsAccessGuard";
import PartnerAgencies from "@pages/hiringCompany/recruitmentAgents/partnerAgencies/partnerAgencies";
import SearchRecruitmentAgencies from "@pages/hiringCompany/recruitmentAgents/searchRecruitmentAgencies/searchRecruitmentAgencies";
import RecruitmentAgentDetails from "@pages/hiringCompany/recruitmentAgentDetails/recruitmentAgentDetails";
import HiringCompanySettings from "@pages/hiringCompany/settings/settings";
import Account from "@pages/hiringCompany/settings/account/account";
import PersonalDetails from "@pages/hiringCompany/settings/account/personalDetails/personalDetails";
import Username from "@pages/hiringCompany/settings/account/username/username";
import CompanyDetails from "@pages/hiringCompany/settings/companyDetails/companyDetails";
import CompanyInfo from "@pages/hiringCompany/settings/companyDetails/companyInfo/companyInfo";
import HiringStaffMembers from "@pages/hiringCompany/HiringStaffMembers/HiringStaffMembers";
import ChangePassword from "@pages/MyAccountDetailsPage/components/ChangePassword";
import CalendarsPage from "@pages/CalendarsPage/CalendarsPage";
import ScheduleSection from "@pages/CalendarsPage/ScheduleSection/ScheduleSection";
import SchedulingSection from "@pages/CalendarsPage/SchedulingSection/SchedulingSection";
import CreateMeetingInvitePage from "@pages/CreateMeetingInvitePage/CreateMeetingInvitePage";
import AddOrEditJobRequirement from "@pages/hiringCompany/AddOrEditJobRequirement/AddOrEditJobRequirement";
import JobRequiremenLayout from "@pages/hiringCompany/JobRequirementDetail/JobRequiremenLayout";
import JobDetails from "@pages/hiringCompany/JobRequirementDetail/Outlets/JobDetails";
import HiringTeam from "@pages/hiringCompany/JobRequirementDetail/Outlets/HiringTeam";
import JobRequirementRecruitmentAgents from "@pages/hiringCompany/JobRequirementDetail/Outlets/RecruitmentAgents";
import CalendarView from "@pages/CalendarsPage/CalendarView/CalendarView";
import CreateMeetingPage from "@pages/CreateMeetingPage/CreateMeetingPage";
import HiringTrackerPage from "@pages/ActivityTracker/HiringTrackerPage";
import { HiringCompanyTrackerStatus } from "@utils/types";
import HiringTrackerPageStatic from "@pages/ActivityTracker/HiringTrackerPageStatic";

const { authLoader } = routerLoaders();

export const HiringCompanyRoutes: RouteObject[] = [
  {
    path: "/tracker",
    loader: authLoader,
    element: <HiringTrackerPage />,
  },
  {
    path: "/tracker-clone",
    loader: authLoader,
    element: <HiringTrackerPageStatic />,
  },
  {
    path: "/requirements",
    loader: authLoader,
    children: [
      {
        index: true,
        element: <RequirementsPage />,
      },
      {
        path: "job/create",
        element: <AddOrEditJobRequirement />,
      },
      {
        path: "job/edit/:id",
        element: <AddOrEditJobRequirement />,
      },
      {
        path: "job/:id",
        element: <JobRequiremenLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={"submitted-candidates"} />,
          },
          {
            path: "submitted-candidates",
            element: <Candidates />,
          },
          {
            path: "job-details",
            element: <JobDetails />,
          },
          {
            path: "recruitment-agents",
            element: <JobRequirementRecruitmentAgents />,
          },
          {
            path: "hiring-team",
            element: <HiringTeam />,
          },
        ],
      },
      {
        path: "job-applicant-detail",
        element: <JobApplicantDetail />,
      },
    ],
  },
  // {
  //   path: "/calender",
  //   loader: authLoader,
  //   children: [
  //     {
  //       index: true,
  //       element: <Calender />,
  //     },
  //     {
  //       path: "meeting-invitation",
  //       element: <CreateMeeting />,
  //     },
  //     {
  //       path: "meeting-invitation/time",
  //       element: <MeetingLayout />,
  //       children: [
  //         {
  //           index: true,
  //           element: <MeetingCalender />,
  //         },
  //       ],
  //     },
  //     {
  //       path: "meeting-invitation/time/review",
  //       element: <MeetingReview />,
  //     },
  //     {
  //       path: "meeting-invitation",
  //       element: <CreateMeeting />,
  //     },
  //   ],
  // },
  {
    path: "/calendar",
    loader: authLoader,
    element: <MeetingLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="meeting" />,
      },
      {
        path: "meeting",
        element: <CalendarsPage />,
        children: [
          {
            index: true,
            element: <Navigate to="schedules" />,
          },
          {
            path: "schedules",
            element: <ScheduleSection />,
          },
          {
            path: "scheduling",
            element: <SchedulingSection />,
          },
          {
            path: "calendar-view",
            element: <CalendarView />,
          },
        ],
      },
      {
        path: "create-meeting",
        element: <CreateMeetingInvitePage />,
      },
      {
        path: "meeting-invitation",
        element: <CreateMeetingPage />,
      },
    ],
  },
  {
    path: "/recruitment-agents",
    loader: authLoader,
    element: (
      <RecruitmentAgentsAccessGuard>
        <RecruitmentAgents />
      </RecruitmentAgentsAccessGuard>
    ),
    children: [
      {
        index: true,
        element: <PartnerAgencies />,
      },
      {
        path: "/recruitment-agents/search-recruitment-agencies",
        element: <SearchRecruitmentAgencies />,
      },
    ],
  },
  {
    path: "/recruitment-agents/:agentId",
    loader: authLoader,
    element: <RecruitmentAgentsAccessGuard />,
    children: [
      {
        index: true,
        element: <RecruitmentAgentDetails />,
      },
      {
        path: "job/:id",
        children: [
          {
            index: true,
            element: <Candidates />,
          },
          {
            path: "job-applicant-detail",
            element: <JobApplicantDetail />,
          },
        ],
      },
    ],
  },
  {
    path: "/settings",
    loader: authLoader,
    element: <HiringCompanySettings />,
    children: [
      {
        path: "/settings/account",
        element: <Account />,
        children: [
          {
            index: true,
            element: <Navigate to={'personal-details'} />
          },
          {
            path: "personal-details",
            element: <PersonalDetails />,
          },
          {
            path: "username",
            element: <Username />,
          },
          {
            path: "change-password",
            element: <ChangePassword />,
          },
        ],
      },
      {
        path: "/settings/company-details",
        element: <CompanyDetails />,
        children: [
          {
            index: true,
            element: <CompanyInfo />,
          },
          {
            path: "account-members",
            element: <HiringStaffMembers />,
          },
        ],
      },
    ],
  },
  {
    path: "/schedule-meeting",
    loader: authLoader,
    element: <HiringCompanySettings />,
  },
];
